import React from 'react';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import { format, parse, isValid } from 'date-fns';
import { FaRegCalendarAlt } from 'react-icons/fa';

const DateTimeLocalInput = ({ 
    label, 
    name, 
    value, 
    onChange, 
    required, 
    disabled = false, 
    allowFutureDates = true,
    minDateTime = null
}) => {
    const parsedValue = value
        ? parse(value, "yyyy-MM-dd'T'HH:mm", new Date())
        : '';

    const handleInputChange = (inputValue) => {
        let dateObj;

        if (typeof inputValue === 'string') {
            dateObj = parse(inputValue, "yyyy-MM-dd HH:mm", new Date());
            if (!isValid(dateObj)) return;
        } else if (inputValue && typeof inputValue.toDate === 'function') {
            dateObj = inputValue.toDate();
        } else if (inputValue instanceof Date) {
            dateObj = inputValue;
        }

        if (dateObj && isValid(dateObj)) {
            const formattedValue = format(dateObj, "yyyy-MM-dd'T'HH:mm");
            onChange({
                target: {
                    name,
                    value: formattedValue,
                },
            });
        }
    };

    // prevent selecting future dates if allowFutureDates = false
    const validDates = (current) => {
        if (!allowFutureDates && current.isAfter(new Date())) {
            return false;
        }
        
        // Prevent selecting dates before minDateTime
        if (minDateTime) {
            const minDate = parse(minDateTime, "yyyy-MM-dd'T'HH:mm", new Date());
            if (isValid(minDate) && current.isBefore(minDate)) {
                return false;
            }
        }
        
        return true;
    };

    return (
        <div className="flex flex-col gap-0.5 w-full relative">
            <label className="text-sm text-gray-700">
                {label}
            </label>
            <div className="relative cursor-pointer">
                <Datetime
                    inputProps={{
                        id: name,
                        name,
                        required,
                        disabled,
                        autoComplete: 'off',
                        className:
                            'w-full pr-10 cursor-pointer pl-4 py-1 text-sm border-2 border-gray-200 bg-input-bg rounded-xl focus:outline-none',
                    }}
                    value={parsedValue}
                    onChange={handleInputChange}
                    dateFormat="YYYY-MM-DD"
                    timeFormat="hh:mm A"
                    utc={false}
                    isValidDate={validDates} 
                />
                <FaRegCalendarAlt className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
            </div>
        </div>
    );
};

export default DateTimeLocalInput;